import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { onIsSidebarVisible } from '../../store/helpers/helpersSlice';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as CollapseFullscreenIcon } from '../../icons/collapse-fullscreen.svg';
import { ReactComponent as ExpandFullscreenIcon } from '../../icons/expand-fullscreen.svg';

import SecondaryButton from 'components/utils/SecondaryButton';

const ShowHideSidebarButton = ({ includeMessage = true }) => {
    const { isSidebarVisible } = useSelector((state) => state.helpers);
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        return () => {
            dispatch(onIsSidebarVisible(true));
        };
    }, [dispatch]);

    const changeExpanded = () => {
        dispatch(onIsSidebarVisible(!isSidebarVisible));
    };

    return (
        <Tooltip
            label={intl.formatMessage({
                id: isSidebarVisible ? 'common_collapse_btn_tooltip' : 'common_expand_btn_tooltip',
            })}
        >
            {includeMessage ? (
                <SecondaryButton
                    leftIcon={!isSidebarVisible ? <CollapseFullscreenIcon /> : <ExpandFullscreenIcon />}
                    size="sm"
                    type="button"
                    variant="secondary"
                    onClick={changeExpanded}
                >
                    <FormattedMessage id={!isSidebarVisible ? 'common_collapse_btn' : 'common_expand_btn'} />
                </SecondaryButton>
            ) : (
                <IconButton
                    leftIcon={!isSidebarVisible ? <CollapseFullscreenIcon /> : <ExpandFullscreenIcon />}
                    size="sm"
                    type="button"
                    variant="circular-icon"
                    onClick={changeExpanded}
                />
            )}
        </Tooltip>
    );
};

export default ShowHideSidebarButton;
